module.exports = __webpack_public_path__ + "img/loaderPrimary.f7145cc2.svg";